export default "__VITE_ASSET__CHkP5l79__"